import type { IsoYearAndWeek } from '../../types/iso-date';

/**
 * Checks whether the given string is a valid ISO year-week in YYYY-Www format.
 * - Weeks are 01–53.
 * - Week 53 is only valid for years that have 53 ISO weeks (per ISO 8601 rules).
 */
export function isIsoYearAndWeek(str: string): str is IsoYearAndWeek {
  const m = /^(\d{4})-W(0[1-9]|[1-4]\d|5[0-3])$/.exec(str);
  if (!m) return false;

  const year = Number(m[1]);
  const week = Number(m[2]);

  if (week < 53) return true;

  // Week 53: only valid if the given year has 53 ISO weeks.
  return hasIsoWeek53(year);
}

// A year has 53 ISO weeks if Jan 1 is a Thursday (ISO weeks start Monday),
// or if it is a leap year and Jan 1 is a Wednesday.
function hasIsoWeek53(year: number): boolean {
  const jan1 = new Date(Date.UTC(year, 0, 1));
  const day = jan1.getUTCDay(); // 0=Sun,1=Mon,...,4=Thu
  const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  return day === 4 || (isLeap && day === 3);
}

